<template>
<div>
    <b-overlay :show="loading" rounded="sm">
        <b-card>
            <b-row>
                <b-col cols="12" md="2" class="align-items-center justify-content-start mb-1 mb-md-0">
                    <!-- <v-select
         v-model="type"
         :reduce="type => type.value"
        :options="statustype"
        :clearable="false"
        :filterable="false"
        style="display:block"
      /> -->
                </b-col>
                <b-col cols="12" md="5" class="align-items-center justify-content-start mb-1 mb-md-0">
                </b-col>
                <b-col cols="12" md="5">
                    <div class="d-flex align-items-center justify-content-end">
                        <v-select :reduce="client => client.value" style="min-width:150px;" v-model="selected_client"  class="mb-1 mr-1" :options="clients" :clearable="false" :filterable="false"/>
                        <flat-pickr v-model="rangeDate" style="min-width:220px;" class="form-control mb-1 mr-1" :config="{ mode: 'range'}" />
                        <b-button variant="primary" class="mb-1" @click="exportToExcel()">
                            <span class="text-nowrap">Export</span>
                        </b-button>
                    </div>
                </b-col>
            </b-row>
        </b-card>
        <b-card>
            <!-- table -->
            <b-table ref="selectableTable" :items="items" :fields="fields" responsive striped class="mb-0">
                <template #cell()="data">
                    <span v-if="data.value == 0" style="color:#ddd;">{{ data.value }}</span>
                    <span v-else>{{ data.value }}</span>
                </template>
                <template #cell(client_alias)="data">
                    <b-badge :variant="'light-primary'" :class="'d-block text-capitalize'+' '+data.value"> {{ data.value }}
                    </b-badge>
                </template>
                 <template #cell(dominant_center_client_alias)="data">
                    <b-badge :variant="'light-primary'" :class="'d-block text-capitalize'+' '+data.value"> {{ data.value }}
                    </b-badge>
                </template>
                 <template #cell(percentage)="data">
                    <b-badge :variant="'light-primary'" class="d-block text-capitalize"> {{ data.value }}%
                    </b-badge>
                </template>
            </b-table>
        </b-card>
        <b-row>
            <b-col class="mt-1">
                Total : {{ totalRows }} , Display Row {{ startRow }} to {{ endRow }}
            </b-col>
            <b-col>
                <!--<b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          first-number
          last-number
          prev-class="prev-item"
          next-class="next-item"
          align="right"
          size="md"
          class="my-0"
          @change="handleChangePage"
        /> -->
            </b-col>
        </b-row>
    </b-overlay>
</div>
</template>

<script>
import BCardCode from '@core/components/b-card-code/BCardCode.vue'

import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import flatPickr from 'vue-flatpickr-component'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import moment from 'moment'
import {
    BTable,
    BAvatar,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCard,
    BOverlay,
    BMedia,
    BMediaAside,
    BMediaBody,
    BCardBody,
    BBadge,
    BLink,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BInputGroupPrepend,
    BModal,
    VBModal
} from 'bootstrap-vue'
export default {
    components: {
        moment,
        BLink,
        BOverlay,
        flatPickr,
        BTable,
        BModal,
        VBModal,
        BAvatar,
        BBadge,
        BRow,
        BCol,
        BFormGroup,
        BFormSelect,
        BPagination,
        BInputGroup,
        BFormInput,
        BInputGroupAppend,
        BInputGroupPrepend,
        BButton,
        BPagination,
        BCardCode,
        BCard,
        BTable,
        BButton,
        BFormGroup,
        BAvatar,
        BCardBody,
        BCardHeader,
        BCardTitle,
        BCardText,
        BCardBody,
        BMedia,
        BAvatar,
        BMediaAside,
        BMediaBody,
        BBadge,
        vSelect,
    },
    directives: {
        Ripple,
    },
    data() {
        return {
            iframe_src: '//cloudfit.pro/invoice.php',
            rangeDate: null,
            searchString: null,
            selected_client: 'ALL',
            type: 'ALL',
            loading: true,
            statustype: [{
                    label: 'ALL',
                    value: 'ALL'
                },
                {
                    label: 'OPEN',
                    value: 'OPEN'
                },
                {
                    label: 'BOOK',
                    value: 'BOOK'
                },
                {
                    label: 'SHOW',
                    value: 'SHOW'
                },
                {
                    label: 'DONE',
                    value: 'DONE'
                },
                {
                    label: 'LOST',
                    value: 'LOST'
                },
            ],
            test_string: null,
            headerTitle: [],
            clients: [],
            headerVal: [],
            status: [{
                    1: 'ACTIVE',
                    2: 'DISABLED',
                    3: 'FREEZE',
                    4: 'TERMINATE',
                    5: 'FREEZE',
                },
                {
                    1: 'light-success',
                    2: 'danger',
                    3: 'info',
                    4: 'primary',
                    5: 'light-info',
                }
            ],
            fieldTypes:null,
            statusOptions: [{
                    label: 'Active',
                    value: 'active'
                },
                {
                    label: 'Disabled',
                    value: 'disabled'
                },
            ],
            centerOptions: [],
            stats: {
                book: 0,
                showed: 0,
                done: 0,
            },
            isAddNewMemberSidebarActive: false,
            searchString: null,
            perPage: 10,
            startRow: 1,
            endRow: 10,
            totalAmount: 0,
            pageOptions: [10, 15, 20],
            totalRows: 1,
            currentPage: 1,
            fields: [],
            /* eslint-disable global-require */
            items: [],
            /* eslint-disable global-require */
            status: [{
                    1: 'Active',
                    2: 'Disabled',
                    3: 'Rejected',
                    4: 'Resigned',
                    5: 'Applied',
                },
                {
                    1: 'light-success',
                    2: 'light-danger',
                    3: 'light-danger',
                    4: 'light-warning',
                    5: 'light-info',
                }
            ],
            selectMode: 'single',
            selected: [],
        }
    },
    watch: {
        selected_client: {
            handler(newValue, oldValue) {
                this.get_data()
            },
        },
        type: {
            handler(newValue, oldValue) {
                this.get_data()
            },
        },

        rangeDate: {
            handler(newValue, oldValue) {
                this.get_data()
            },
        },
        currentPage: {
            handler(newValue, oldValue) {
                this.get_data()
            },
        },
        searchString: {
            handler(newValue, oldValue) {
                // console.log("search")
                this.searchString = newValue.toUpperCase()
                this.handleSearch()
            },
        },
        perPage: {
            handler(newValue, oldValue) {
                if (newValue < 9) {
                    this.perPage = 10
                }
                // console.log("search")
                this.handleSearch()
            },
        },
    },
    created() {
        this.get_data()
        //this.get_center_data()
    },
    methods: {
        exportToExcel() {
         import('@/@core/Export2Excel').then(excel => {
           const list = this.items
           const data = this.formatJson(this.headerVal, list)
           
           excel.export_json_to_excel({
             header: this.headerTitle,
             data,
             filename: 'report-member-entry-count',
             autoWidth: true,
             bookType: 'xlsx'
           })
           //this.clearFields()
         })
       },
formatJson(filterVal, jsonData) {
  return jsonData.map(row =>
    filterVal.map(key => {
      const value = row[key]
      const type = this.fieldTypes[key]

      if (value === null || value === '') return ''

      switch (type) {
        case 'int':
          return parseInt(value)
        case 'float':
          return parseFloat(value)
        case 'boolean':
          return value ? 'Yes' : 'No'
        case 'date':
          return moment(value).format('YYYY-MM-DD')
        case 'datetime':
          return moment(value).format('YYYY-MM-DD HH:mm')
        default:
          return value
      }
    })
  )
},
        get_data(searchString = null) {
            this.loading = true
            var splitted = []
            if (this.rangeDate === null) {
                splitted[0] = moment().subtract(2, 'days').format('YYYY-MM-DD')
                splitted[1] = moment().add(0, 'days').format("YYYY-MM-DD")
                this.rangeDate = moment().subtract(2, 'days').format('YYYY-MM-DD') + " to " + moment().add(0, 'days').format("YYYY-MM-DD")
            } else {
                if (this.rangeDate.includes(" to ")) {
                    splitted = this.rangeDate.split(" to ");
                } else {
                    splitted[0] = this.rangeDate
                    splitted[1] = this.rangeDate
                }
            }
            this.$http.get(process.env.VUE_APP_API_BASE + `/report/member-entry-count/` + this.$store.getters['center/currentCenterId'] + `/` + splitted[0] + `/` + splitted[1] + `/?selected_client=` + this.selected_client)
                .then(res => {
                    this.loading = false
                    if (res.data.result === true) {
                        this.clients = res.data.clients
                        this.items = res.data.records
                        this.fields = res.data.fields
                        this.headerTitle = res.data.excel_fields.map(f => f.label)
                        this.headerVal = res.data.excel_fields.map(f => f.key)
                        this.fieldTypes = res.data.excel_fields.reduce((map, f) => {
                          map[f.key] = f.type
                          return map
                        }, {})
                    } else {
                        this.$toast({
                            component: ToastificationContent,
                            position: 'top-center',
                            props: {
                                title: 'Error',
                                icon: 'XIcon',
                                variant: 'danger',
                                text: res.data.message,
                            },
                        })
                    }
                })
        },
        get_center_data() {
            this.$http.get(process.env.VUE_APP_API_BASE + '/centers/')
                .then(res => {
                    this.centerOptions = res.data.centers
                })
        },
        handleChangePage() {

            //  this.get_data()
        },
        onRowSelected(items) {
            this.selected = items[0]
            console.log(items)
            if (items[0].is_pdf == 'Y') {
                this.iframe_src = '//www.cloudfit.pro/pdf/INVOICE_' + items[0].code + '.pdf'
                console.log(this.iframe_src)

            } else {
                this.iframe_src = process.env.VUE_APP_API_BASE + '/invoice.php?print=n&code=' + items[0].id
            }
            this.transaction_id = items[0].transaction_id
            this.$refs['my-modal'].show()
        },
        close() {
            this.iframe_src = '//www.cloudfit.pro/invoice.php'
            this.$refs['my-modal'].hide()
        },
        selectAllRows() {
            this.$refs.selectableTable.selectAllRows()
        },
        clearSelected() {
            this.$refs.selectableTable.clearSelected()
        },
        selectThirdRow() {
            // Rows are indexed from 0, so the third row is index 2
            this.$refs.selectableTable.selectRow(2)
        },
        unselectThirdRow() {
            // Rows are indexed from 0, so the third row is index 2
            this.$refs.selectableTable.unselectRow(2)
        },

        handleSearch() {
            // let _print = `The user searched for: ${searching}\n`
            // this.$refs.pre.appendChild(document.createTextNode(_print))
            // this.searchString = searching
            // this.currentx = 1
            // this.get_data()
            this.searchTimeOut()
        },
        searchTimeOut() {
            if (this.timer) {
                clearTimeout(this.timer)
                this.timer = null
            }
            this.timer = setTimeout(() => {
                // your code
                this.currentPage = 1
                this.get_data(this.searchString)
            }, 500)
        },
    },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
<style lang="scss">
.b-table-selectable {
    .feather {
        font-size: 1.3rem;
    }
}
.TT24NTK {
    background-color: #ffe5e5 !important;
    color: #5a1010;
}
.TT24MKK {
    background-color: #e6f7ff !important;
    color: #0b3d59;
}
.TT24HMT {
    background-color: #e9ffe8 !important;
    color: #145a1f;
}
.TT24CTL {
    background-color: #fff3cc !important;
    color: #5c4300;
}
.TT24CSW {
    background-color: #f1e8ff !important;
    color: #3f2466;
}
.AFYT {
    background-color: #ffe8d6 !important;
    color: #6b2f00;
}
</style>
